import useRequest from '@/websdk/utils/request';
export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/system/settings',
    name: 'systemSettingsPUt',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
